import { LT_LIFESTYLE_EXPENSES_DATA_RECEIVED, LT_LIFESTYLE_EXPENSE_UNLOADED, LT_LIFESTYLE_EXPENSE_SAVED, LT_LIFESTYLE_EXPENSE_DELETED } from './types';
import api from 'api';

export const expensesLTDataReceived = (data) => ({
  type: LT_LIFESTYLE_EXPENSES_DATA_RECEIVED,
  data
})

export const expenseLTDataUnload = () => ({
  type: LT_LIFESTYLE_EXPENSE_UNLOADED
})

export const expenseSaved = (data) => ({
  type: LT_LIFESTYLE_EXPENSE_SAVED,
  data
})

export const expenseDeleted = (data) => ({
  type: LT_LIFESTYLE_EXPENSE_DELETED,
  data
})

export const unloadExpense = () => dispatch => {
  dispatch(expenseLTDataUnload())
}

// TODO: catch with user logout and user data not received
export const getLifestyleExpenses = (view = false) => (dispatch) =>
    api.bmc.expenses.getExpenses(view?'viewTY':'').then(res => {
    dispatch(expensesLTDataReceived(res))
  })

// TODO: doebatsia do tracy
export const postLifestyleExpense = (data) => dispatch =>
  api.bmc.expenses.postExpense(data).then(res=>{
    dispatch(expenseSaved(res))
  })

// TODO: doebatsia do tracy 2, figure out the correct table
export const deleteLifestyleExpense = (data) => dispatch =>
  api.bmc.expenses.deleteExpense(data).then(res=>{
    dispatch(expenseDeleted(data))
  })